var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mypage-language-setting-pane"},[_c('language-select-list-section',{attrs:{"listData":_vm.listData,"selectedID":_vm.selectedID},on:{"selectChange":_vm.changeSelected}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }